import _defineProperty from "/home/runner/work/sonos-web-app-tech-blog/sonos-web-app-tech-blog/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { css as _css } from "@styled-system/css";
import * as styledFns from "@sonos-inc/web-ui-styled-system";
var styledFunctions = styledFns;
var transforms = Object.keys(styledFunctions).map(function (k) {
  return styledFunctions[k].config;
}).reduce(function (obj, c) {
  return _extends({}, obj, c);
}, {});

function parseStyledObject(styledObj) {
  return Object.keys(styledObj).reduce(function (obj, key) {
    var value = styledObj[key];
    var transform = transforms[key];

    if (!Array.isArray(value) && value !== null && typeof value === "object") {
      return _extends({}, obj, _defineProperty({}, key, parseStyledObject(value)));
    }

    if (transform) {
      var transformedValue = Array.isArray(value) ? value.map(function (v) {
        return transform(v);
      }).flatMap(function (v) {
        return v ? Object.values(v)[0] : [null];
      }) : transform(value);
      return Array.isArray(value) ? _extends({}, obj, _defineProperty({}, key, transformedValue)) : _extends({}, obj, transformedValue);
    }

    return _extends({}, obj, _defineProperty({}, key, value));
  }, {});
}

export function css(styledObj) {
  return _css(parseStyledObject(styledObj));
}
export default css;